// extracted by mini-css-extract-plugin
module.exports = {"link":"Logo_link__Lh4uv"};